export { FastshiftChampionCard } from "./fastshift-champion-card";
